// jl-design-system
import validate from 'jl-design-system/form/validation/validate';
import { getFormInitialValuesFromAddress } from 'jl-design-system/utils/address/address';
import getAddressFieldsConfig from 'jl-design-system/form/configs/address';
import {
  FIRST_NAME_DATA_STANDARDS,
  LAST_NAME_DATA_STANDARDS,
  PHONE_NUMBER,
} from 'jl-design-system/form/fields';
// lodash
import get from 'lodash/get';

import titleFieldConfig from '../features/titleDropdownUtil';
import { countryCodeIsInternational } from '../address/addressHelpers';
import makePostcodeOptional from '../address/makePostcodeOptional';
import { internationalPhoneNumberLazy } from '../lazy/lazyMainBundle';
import featureConstants from '../../constants/featureConstants';
import getInternationalPhoneNumberConfig from '../lazy/internationalPhoneNumberConfig';

const INTERNATIONAL_PHONE_NUMBER = internationalPhoneNumberLazy;

export function getAddressFormConfig(addressFormValues, isDeliveryAddress) {

  const { countryCode } = addressFormValues;

  const ADDRESS_FIELDS = getAddressFieldsConfig({
    international: countryCodeIsInternational(countryCode),
    internationalMode: countryCodeIsInternational(countryCode),
    countryCode,
    addressLines: 3,
    maxAddressLines: 3,
    actions: {},
    configExtras: {},
    allowAsciiOnly: true,
    enableGBCounty: !!addressFormValues?.countyStateOrProvince,
  });

  const postcodeOptional = countryCodeIsInternational(countryCode);
  if (postcodeOptional && !isDeliveryAddress) {
    // international addresses can't be selected for delivery so this should only affect billing addresses
    makePostcodeOptional(ADDRESS_FIELDS);
  }

  const useTitleDropdown = window[featureConstants.TITLE_DROPDOWN_ENABLED];

  const titleField = titleFieldConfig(useTitleDropdown);

  return {
    fields: [
      titleField,
      FIRST_NAME_DATA_STANDARDS,
      LAST_NAME_DATA_STANDARDS,
      getInternationalPhoneNumberConfig(),
      ...ADDRESS_FIELDS,
    ],
  };
}

export function getAddressValidationErrors(addressRecord = {}, isDeliveryAddress) {
  const values = getFormInitialValuesFromAddress(addressRecord);

  let phoneNumberCountryCode;

  if (values.phoneNumber) {
    // we need to supply phoneNumberCountryCode field value to validate()
    // so that validation matches that when InternationalPhoneNumberInput is rendered in an AddressForm
    const InternationalPhoneNumberInput = get(INTERNATIONAL_PHONE_NUMBER(), 'component');
    const params = [values.phoneNumber, values.countryCode || 'GB'];
    phoneNumberCountryCode = InternationalPhoneNumberInput.parseInitialPhoneNumber(...params).countryCode;
  }

  const addressFormValues = {
    ...values,
    phoneNumberCountryCode,
  };
  const addressFormConfig = getAddressFormConfig(addressFormValues, isDeliveryAddress);

  return validate(addressFormValues, { config: addressFormConfig });
}

export function isNameAndNumberComplete(values) {
  const useTitleDropdown = window[featureConstants.TITLE_DROPDOWN_ENABLED];
  const titleField = titleFieldConfig(useTitleDropdown);

  return !!values[titleField.name] &&
    !!values[FIRST_NAME_DATA_STANDARDS.name] &&
    !!values[LAST_NAME_DATA_STANDARDS.name] &&
    !!values[PHONE_NUMBER.name];
}

function isAddressValid(addressRecord = {}) {
  const errors = getAddressValidationErrors(addressRecord);

  return Object.keys(errors).reduce((acc, key) => {
    if (acc && errors[key]) {
      return false;
    }
    return acc;
  }, true);

}

export default isAddressValid;
